<div class="dropdown dropdown-chart" ngbDropdown (click)="$event.stopPropagation()">
  <a id="chartDropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false" [hidden]="!options">
    <span class="dropdown-toggle-name" data-toggle="tooltip" title=""
        [attr.data-original-title]="selectedOption ? selectedOption.text : ''"
        aria-describedby="tooltip475475">{{selectedOption ? selectedOption.text : ""}}</span>
  </a>
  <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="chartDropdown" x-placement="bottom-start"
    style="position: absolute; transform: translate3d(0px, 14px, 0px); top: 0px; left: 0px; will-change: transform;">
    @for (option of options || []; track $index) {
      <a class="dropdown-item"
        (click)="optionSelected(option)">{{option.text}}</a>
    }
  </div>
</div>
